import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormControl, FormLabel, Input, Button, Flex } from '@chakra-ui/react';
import axios from 'axios';
import { useLanguage } from '../components/LanguageContext';

const Login = () => {
  const { language } = useLanguage();
  const isEnglish = language === 'en';

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const navigate = useNavigate();
  const [setAuthChecked] = useState(false); // controls form visibility

  // If user is already logged in don't show login form -- NEED TO INVESTIGATE WHY ITS MAKING MORE THAN ONE CALL TO BACKEND 
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await axios.get('/api/auth/check'); // Checking auth status
        if (res.data.authenticated) {
          navigate('/dashboard'); // Redirect if already logged in
        }
      } catch (err) {
        if (err.response?.status === 401) {
          // 401 error indicates no valid token, so proceed with login form
          console.log("User is not authenticated or token expired");
        } else {
          console.error("Error while checking authentication", err);
        }
      } finally {
        setAuthChecked(true); // proceed regardless of result
      }
    };

    checkAuth();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const { data: loginData } = await axios.post("/api/login", formData);
      console.log(loginData);

      window.dispatchEvent(new Event('userLoggedIn'));

      const { data: progress } = await axios.get("/api/progress");
      console.log("User progress:", progress);

      if (!progress.personalInfo) {
        console.log("personalInfo not found, redirecting to personal info page");
        navigate("/signup/personal-info");
      } else if (!progress.contract) {
        console.log("contract not found, redirecting to contract page");
        navigate("/signup/contract");
      } else if (!progress.payment) {
        console.log("payment not found, redirecting to payment page");
        navigate("/signup/create-payment");
      } else {
        console.log("going to dashboard");
        navigate("/dashboard");
      }
    } catch (error) {
      if (error.response?.status !== 200) {
        alert(isEnglish ? "Invalid Email or Password" : "Correo electrónico o contraseña inválidos");
      } else {
        console.error("Login or progress check error", error);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value} = e.target;
    setFormData({...formData, [name]: value})
  };


  return ( 
    <form onSubmit={handleSubmit}>
    <Flex
      align="center"
      wrap="wrap"
      justify="space-around"
      minHeight={{ base: "60vh", lg: "50vh" }}
      maxW={{ base: "md", lg: "lg" }}
      mt={8}
      p={8}
    >
      <FormControl mt={4} isRequired>
        <FormLabel fontSize="md">{isEnglish ? "Email" : "Correo Electrónico"}</FormLabel>
        <Input type="email" name="email" value={formData.email} onChange={handleChange} color="blue.600" required />
      </FormControl>
      <FormControl mt={4} isRequired>
        <FormLabel fontSize="md">{isEnglish ? "Password" : "Contraseña"}</FormLabel>
        <Input type="password" name="password" value={formData.password} onChange={handleChange} color="blue.600" required />
      </FormControl>
      <Button type="submit" colorScheme="blue" mt={4}>{isEnglish ? "Next" : "Siguiente"}</Button>
    </Flex>
  </form>
  );
}

export default Login;
